import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import SyncSvg from '../assets/SyncSvg';
import vector1a from '../assets/vector1a.png';
import vector2a from "../assets/vector2a.png";
import icon_check from "../assets/icon_check.svg";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useSelector } from 'react-redux';
import config from '../../../../config/config';
gsap.registerPlugin(ScrollTrigger);

const Slide1 = () => {
  const { yearEndData } = useSelector(state => state.commonSetting);
  const scroll = {
    scroller: ".st-year-end-slides-scroll",
    trigger: ".year-wrap-slide-1",
    // markers: true,
    start: "top center",
    toggleActions: "restart none none reverse",
  };
  useEffect(() => {
    gsap.fromTo(
      ".orders-synced",
      {
        opacity: 0,
        x: -100,
      },
      {
        opacity: 1,
        x: 0,
        duration: 3,
        scrollTrigger: scroll,
      },
    );
    gsap.fromTo(
      ".fade-in",
      {
        opacity: 0,
        y: -100,
      },
      {
        opacity: 1,
        delay: 2,
        y: 0,
        duration: 2,
        scrollTrigger: scroll,
      },
    );
  }, [])
  return (
    <div className="year-wrap-slide-1">
      <div className="year-wrap-slide-1-decor-1 position-absolute right--10 bottom-0">
        <img src={vector1a} />
      </div>
      <div className="year-wrap-slide-1-decor-1 position-absolute top-0 w-20">
        <img src={vector2a} />
      </div>
      <div className="position-absolute bottom-10 left-12">
        <span className="d-text-10 d-text-blue2">
          *total synced orders for store {config.shop}
        </span>
      </div>
      <div className="w-80 m-auto h-100">
        <Row>
          <Col lg="6">
            <div>
              <div className="d-flex flex-column gap-2 align-items-center d-text-primary mb-5">
                <b className="d-text-50">In 2022, you had</b>

                <b className="d-text-100 orders-synced">
                  {yearEndData?.order_synced}
                </b>
                <div className='d-flex'>
                  <b className="d-text-50">total synced orders </b>
                  <span
                    style={{ lineHeight: "50px" }}
                    className="d-text-20"
                  >
                    *
                  </span>
                </div>
              </div>
              <div className="text-center d-mt-10">
                <span className="d-text-32 fade-in">
                  Quite an impressive number you got there! 2022 must be a great
                  year for you 🥳.
                </span>
              </div>
            </div>
          </Col>
          <Col lg="6">
            <div className="d-flex justify-content-end">
              <div className="rounded-circle p-5 bg-white fit-content rotate-animation position-relative w-40">
                <SyncSvg />
                <div className="position-absolute right--5 bottom-0">
                  <img src={icon_check} />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Slide1;